import { comparer } from 'mobx';
import { withKeys } from 'bernie-core/dist/util/merge';
import { DateUtils } from 'utils/date-utils';
import { InventoryType, ShoppingPathType } from '__generated__/api';
export function searchCriteriaToPropertyRoomInput(rooms) {
  if (!rooms) {
    return;
  }
  return rooms.map(room => {
    var _a, _b;
    return {
      childAges: (_b = (_a = room.children) === null || _a === void 0 ? void 0 : _a.map(child => child.age)) !== null && _b !== void 0 ? _b : [],
      numberOfAdults: room.adults
    };
  });
}
export function adaptToPropertyNaturalKeyInputs(paymentPlanStartDate, paymentPlanEndDate, rooms, inventoryType, roomTypeCode, ratePlanCode, ratePlanType, id, isAttach, roomIndex, isMixMatchEnabled, isPackage) {
  if (!paymentPlanStartDate || !paymentPlanEndDate || paymentPlanStartDate.split(',').length !== ratePlanCode.split(',').length) {
    return;
  }
  return ratePlanCode.split(',').filter(singleRatePlan => singleRatePlan).map((singleRatePlan, idx) => {
    var _a, _b;
    return adaptToPropertyNaturalKeyInput((_a = paymentPlanStartDate.split(',')[idx]) !== null && _a !== void 0 ? _a : '', (_b = paymentPlanEndDate.split(',')[idx]) !== null && _b !== void 0 ? _b : '', rooms, inventoryType, roomTypeCode, singleRatePlan, ratePlanType, id, isAttach, roomIndex, isMixMatchEnabled, isPackage);
  });
}
function adaptToPropertyNaturalKeyInput(paymentPlanStartDate, paymentPlanEndDate, rooms, inventoryType, roomTypeCode, ratePlanCode, ratePlanType, id, isAttach, roomIndex, isMixMatchEnabled, isPackage) {
  let roomInput = rooms;
  if (isMixMatchEnabled && roomIndex !== null && roomIndex && roomIndex >= 0) {
    roomInput = [rooms[roomIndex]];
  }
  let shoppingPath = isAttach ? ShoppingPathType.ATTACH : ShoppingPathType.STANDALONE;
  if (isPackage) shoppingPath = ShoppingPathType.PACKAGE;
  return {
    checkIn: fromDateToBexApiDate(new Date(paymentPlanStartDate)),
    checkOut: fromDateToBexApiDate(new Date(paymentPlanEndDate)),
    id,
    inventoryType: adaptInventoryType(inventoryType),
    ratePlanId: ratePlanCode,
    roomTypeId: roomTypeCode,
    ratePlanType,
    rooms: searchCriteriaToPropertyRoomInput(roomInput),
    shoppingPath: shoppingPath
  };
}
export function adaptToPropertyNaturalKeyInputForPackages(checkInDate, checkOutDate, rooms, inventoryType, roomTypeCode, ratePlanCode, ratePlanType, hotelId) {
  return {
    checkIn: checkInDate,
    checkOut: checkOutDate,
    id: hotelId,
    inventoryType: adaptInventoryType(inventoryType),
    ratePlanId: ratePlanCode,
    roomTypeId: roomTypeCode,
    ratePlanType: ratePlanType,
    rooms: searchCriteriaToPropertyRoomInput(rooms),
    shoppingPath: ShoppingPathType.PACKAGE
  };
}
export function adaptToCartPropertySearchContextInput(searchCriteria, regionId) {
  return {
    checkIn: searchCriteria.startDate ? DateUtils.parseDateString(searchCriteria.startDate) : undefined,
    checkOut: searchCriteria.endDate ? DateUtils.parseDateString(searchCriteria.endDate) : undefined,
    rooms: toPropertyRoomInputs(searchCriteria),
    regionId
  };
}
// TODO Remove this adaption after moving this to shared-ui.
// checkIn and checkOut in propertyNaturalKeys has additional field which is not required by property add cart mutation
export function adaptToCartPropertyPrimaryKeyInput(propertyNaturalKeys) {
  return propertyNaturalKeys.map(propertyNaturalKey => {
    var _a, _b, _c, _d, _e, _f;
    const adaptedPropertyNaturalKey = Object.assign(Object.assign({}, propertyNaturalKey), {
      checkIn: {
        day: (_a = propertyNaturalKey === null || propertyNaturalKey === void 0 ? void 0 : propertyNaturalKey.checkIn) === null || _a === void 0 ? void 0 : _a.day,
        month: (_b = propertyNaturalKey === null || propertyNaturalKey === void 0 ? void 0 : propertyNaturalKey.checkIn) === null || _b === void 0 ? void 0 : _b.month,
        year: (_c = propertyNaturalKey === null || propertyNaturalKey === void 0 ? void 0 : propertyNaturalKey.checkIn) === null || _c === void 0 ? void 0 : _c.year
      },
      checkOut: {
        day: (_d = propertyNaturalKey === null || propertyNaturalKey === void 0 ? void 0 : propertyNaturalKey.checkOut) === null || _d === void 0 ? void 0 : _d.day,
        month: (_e = propertyNaturalKey === null || propertyNaturalKey === void 0 ? void 0 : propertyNaturalKey.checkOut) === null || _e === void 0 ? void 0 : _e.month,
        year: (_f = propertyNaturalKey === null || propertyNaturalKey === void 0 ? void 0 : propertyNaturalKey.checkOut) === null || _f === void 0 ? void 0 : _f.year
      }
    });
    return adaptedPropertyNaturalKey;
  });
}
function toPropertyRoomInputs(searchCriteria) {
  if (!searchCriteria.rooms || searchCriteria.rooms.length === 0) {
    return;
  }
  return searchCriteria.rooms.map(room => ({
    childAges: room.children && room.children.map(child => child.age) || [],
    numberOfAdults: room.adults
  }));
}
const getFeesDescriptions = (fees = []) => fees.map(({
  description
}) => description).filter(x => x);
const getFencingAttributes = ratePlanPriceDetails => {
  var _a;
  return (_a = ratePlanPriceDetails === null || ratePlanPriceDetails === void 0 ? void 0 : ratePlanPriceDetails.offerBookButton) === null || _a === void 0 ? void 0 : _a.inputs.filter(input => input && input.name === 'fencingAttributes').map(input => input.value)[0];
};
const getAvailability = (allItems, index, item, ratePlanPriceDetails) => {
  var _a, _b;
  const minRoomsLeft = (_a = ratePlanPriceDetails === null || ratePlanPriceDetails === void 0 ? void 0 : ratePlanPriceDetails.availability) === null || _a === void 0 ? void 0 : _a.minRoomsLeft;
  const available = (_b = ratePlanPriceDetails === null || ratePlanPriceDetails === void 0 ? void 0 : ratePlanPriceDetails.availability) === null || _b === void 0 ? void 0 : _b.available;
  const notMinRoomsLeft = minRoomsLeft === null || minRoomsLeft > numberOfDuplicates(allItems.slice(0, index), item);
  return available && notMinRoomsLeft;
};
const getRoomImage = (gallery, isMixMatchEnabled, offers) => {
  var _a, _b, _c, _d, _e;
  return isMixMatchEnabled ? (_d = (_c = (_b = (_a = offers[0]) === null || _a === void 0 ? void 0 : _a.offer) === null || _b === void 0 ? void 0 : _b.units[0]) === null || _c === void 0 ? void 0 : _c.photos[0]) === null || _d === void 0 ? void 0 : _d.url : (_e = gallery === null || gallery === void 0 ? void 0 : gallery.featured) === null || _e === void 0 ? void 0 : _e.url;
};
const getAdultsAndChildren = (firstNaturalKey, firstNaturalKeyRoom, isMixMatchEnabled) => {
  const adults = isMixMatchEnabled && firstNaturalKeyRoom ? firstNaturalKeyRoom.numberOfAdults : numberOfAdults(firstNaturalKey.rooms);
  const children = isMixMatchEnabled && (firstNaturalKeyRoom === null || firstNaturalKeyRoom === void 0 ? void 0 : firstNaturalKeyRoom.childAges) ? firstNaturalKeyRoom.childAges.length : numberOfChildren(firstNaturalKey.rooms);
  return {
    adults,
    children
  };
};
export function cartItemToInCartProperty(isMixMatchEnabled) {
  return (item, index, allItems) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    const {
      id,
      summary,
      offers,
      gallery
    } = item;
    const unit = (_b = (_a = offers[0]) === null || _a === void 0 ? void 0 : _a.offer) === null || _b === void 0 ? void 0 : _b.units[0];
    const marketingChannelId = ((_d = (_c = offers[0]) === null || _c === void 0 ? void 0 : _c.offer) === null || _d === void 0 ? void 0 : _d.marketingChannelId) || undefined;
    const ratePlanPriceDetails = (_e = unit === null || unit === void 0 ? void 0 : unit.ratePlans[0]) === null || _e === void 0 ? void 0 : _e.priceDetails[0];
    const leadPrice = (_f = ratePlanPriceDetails === null || ratePlanPriceDetails === void 0 ? void 0 : ratePlanPriceDetails.price) === null || _f === void 0 ? void 0 : _f.lead;
    const totalPrice = (_g = ratePlanPriceDetails === null || ratePlanPriceDetails === void 0 ? void 0 : ratePlanPriceDetails.price) === null || _g === void 0 ? void 0 : _g.total;
    const priceWithLoyaltyPoints = (_h = ratePlanPriceDetails === null || ratePlanPriceDetails === void 0 ? void 0 : ratePlanPriceDetails.priceAfterLoyaltyPointsApplied) === null || _h === void 0 ? void 0 : _h.lead;
    const fencingAttributes = getFencingAttributes(ratePlanPriceDetails);
    const fees = getFeesDescriptions(ratePlanPriceDetails === null || ratePlanPriceDetails === void 0 ? void 0 : ratePlanPriceDetails.fees);
    const available = getAvailability(allItems, index, item, ratePlanPriceDetails);
    const offerIndex = (_k = (_j = offers[0]) === null || _j === void 0 ? void 0 : _j.offerIndex) !== null && _k !== void 0 ? _k : 0;
    const naturalKeys = (_l = offers[0]) === null || _l === void 0 ? void 0 : _l.naturalKeys;
    const firstNaturalKey = naturalKeys === null || naturalKeys === void 0 ? void 0 : naturalKeys[0];
    const rooms = (firstNaturalKey === null || firstNaturalKey === void 0 ? void 0 : firstNaturalKey.rooms) || [];
    const firstNaturalKeyRoom = rooms[index];
    const lastNaturalKey = naturalKeys === null || naturalKeys === void 0 ? void 0 : naturalKeys[naturalKeys.length - 1];
    const propertyId = Number(firstNaturalKey === null || firstNaturalKey === void 0 ? void 0 : firstNaturalKey.id);
    const roomImage = getRoomImage(gallery, isMixMatchEnabled, offers);
    const {
      adults,
      children
    } = getAdultsAndChildren(firstNaturalKey, firstNaturalKeyRoom, isMixMatchEnabled);
    return {
      id,
      marketingChannelId,
      name: summary === null || summary === void 0 ? void 0 : summary.name,
      checkin: (_o = (_m = firstNaturalKey === null || firstNaturalKey === void 0 ? void 0 : firstNaturalKey.checkIn) === null || _m === void 0 ? void 0 : _m.isoFormat) !== null && _o !== void 0 ? _o : '',
      checkout: (_q = (_p = lastNaturalKey === null || lastNaturalKey === void 0 ? void 0 : lastNaturalKey.checkOut) === null || _p === void 0 ? void 0 : _p.isoFormat) !== null && _q !== void 0 ? _q : '',
      propertyId,
      image: roomImage,
      city: ((_s = (_r = summary === null || summary === void 0 ? void 0 : summary.location) === null || _r === void 0 ? void 0 : _r.address) === null || _s === void 0 ? void 0 : _s.city) || '',
      adults,
      children,
      rooms: (_u = (_t = firstNaturalKey === null || firstNaturalKey === void 0 ? void 0 : firstNaturalKey.rooms) === null || _t === void 0 ? void 0 : _t.length) !== null && _u !== void 0 ? _u : 0,
      ratePlan: {
        roomName: (unit === null || unit === void 0 ? void 0 : unit.name) || undefined,
        available,
        leadPrice: {
          currencySymbol: (_v = leadPrice === null || leadPrice === void 0 ? void 0 : leadPrice.currency) === null || _v === void 0 ? void 0 : _v.symbol,
          formatted: leadPrice === null || leadPrice === void 0 ? void 0 : leadPrice.formatted,
          raw: leadPrice === null || leadPrice === void 0 ? void 0 : leadPrice.raw
        },
        totalPrice: {
          currencySymbol: (_w = totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.currency) === null || _w === void 0 ? void 0 : _w.symbol,
          formatted: totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.formatted,
          raw: totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.raw
        },
        priceAfterLoyaltyPointsApplied: {
          currencySymbol: (_x = priceWithLoyaltyPoints === null || priceWithLoyaltyPoints === void 0 ? void 0 : priceWithLoyaltyPoints.currency) === null || _x === void 0 ? void 0 : _x.symbol,
          formatted: priceWithLoyaltyPoints === null || priceWithLoyaltyPoints === void 0 ? void 0 : priceWithLoyaltyPoints.formatted,
          raw: priceWithLoyaltyPoints === null || priceWithLoyaltyPoints === void 0 ? void 0 : priceWithLoyaltyPoints.raw
        },
        fees
      },
      offerIndex,
      fencingAttributes
    };
  };
}
export function fromDateToBexApiDate(date) {
  if (!date) return;
  return {
    day: date.getDate(),
    month: date.getMonth() + 1,
    year: date.getFullYear()
  };
}
function numberOfDuplicates(items, item) {
  return items.filter(otherItem => {
    var _a, _b, _c, _d;
    const compareKeys = ['id', 'roomTypeId', 'checkIn', 'checkOut'];
    return comparer.structural(withKeys(compareKeys).merge({}, (_b = (_a = item.offers[0]) === null || _a === void 0 ? void 0 : _a.naturalKeys[0]) !== null && _b !== void 0 ? _b : {}), withKeys(compareKeys).merge({}, (_d = (_c = otherItem.offers[0]) === null || _c === void 0 ? void 0 : _c.naturalKeys[0]) !== null && _d !== void 0 ? _d : {}));
  }).map(i => {
    var _a, _b, _c;
    return (_c = (_b = (_a = i.offers[0]) === null || _a === void 0 ? void 0 : _a.naturalKeys[0]) === null || _b === void 0 ? void 0 : _b.rooms.length) !== null && _c !== void 0 ? _c : 0;
  }).reduce((acc, roomsCount) => acc + roomsCount, 0);
}
export function numberOfAdults(rooms) {
  if (!(rooms === null || rooms === void 0 ? void 0 : rooms.length)) return 0;
  return rooms.reduce((acc, room) => acc + room.numberOfAdults, 0);
}
export function numberOfChildren(rooms) {
  if (!(rooms === null || rooms === void 0 ? void 0 : rooms.length)) return 0;
  return rooms.reduce((acc, room) => {
    var _a;
    const roomChildren = ((_a = room === null || room === void 0 ? void 0 : room.childAges) === null || _a === void 0 ? void 0 : _a.length) || 0;
    return acc + roomChildren;
  }, 0);
}
export function adaptInventoryType(inventoryType) {
  return inventoryType ? InventoryType[inventoryType] : InventoryType.MERCHANT;
}